/**
 * Created: 2026-03-16 - Shared utility to read the current ref code from all available sources
 */

const STORAGE_KEY = "tracking_attribution";
const SESSION_REF_KEY = "tracking_ref_code";
const ATTRIBUTION_TTL_DAYS = 30;

/**
 * Reads the current campaign ref code from sessionStorage, localStorage, or URL params.
 * Returns null if no ref code is available.
 */
export function getRefCode(): string | null {
  try {
    // 1. sessionStorage (most reliable within tab)
    const sessionRef = sessionStorage.getItem(SESSION_REF_KEY);
    if (sessionRef) return sessionRef;

    // 2. localStorage attribution (with TTL check)
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const data = JSON.parse(raw);
      const age = Date.now() - data.captured_at;
      if (age <= ATTRIBUTION_TTL_DAYS * 24 * 60 * 60 * 1000 && data.code) {
        return data.code;
      }
    }

    // 3. URL params (last resort)
    const urlRef = new URLSearchParams(window.location.search).get("ref");
    if (urlRef) return urlRef;

    return null;
  } catch {
    return null;
  }
}

/**
 * Restores attribution data in localStorage and sessionStorage from a ref code.
 * Used after auth redirect to re-establish tracking context.
 */
export function restoreAttribution(refCode: string): void {
  try {
    sessionStorage.setItem(SESSION_REF_KEY, refCode);
    
    const existingAttribution = localStorage.getItem(STORAGE_KEY);
    if (!existingAttribution) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        code: refCode,
        captured_at: Date.now(),
        landing_page: window.location.pathname,
      }));
    }
  } catch {
    // Silent failure — don't break UX
  }
}
